module.exports = __webpack_public_path__ + "static/media/salon.a209159a.jpg";